export default __webpack_public_path__ + "static/media/MaleHeadLeft.938b4974.png";